import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Dsst from "../pages/dsst/page";
import Tmt from "../pages/tmt/page";
import TmtSpick from "../pages/tmt-spick/page";
import SpatialSpanShinhan from "../pages/spatial-span-shinhan/page";
import SpatialSpanSpick from "../pages/spatial-span-spick/page";
import DsstShinhan from "../pages/dsst-shinhan/page";
import DsstSpick from "../pages/dsst-spick/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dsst",
    element: <Dsst />,
  },
  {
    path: "/tmt",
    element: <Tmt />,
  },
  {
    path: "/tmt-spick",
    element: <TmtSpick />,
  },
  {
    path: "/spatial-span-shinhan",
    element: <SpatialSpanShinhan />,
  },
  {
    path: "/spatial-span-spick",
    element: <SpatialSpanSpick />,
  },
  {
    path: "/dsst-shinhan",
    element: <DsstShinhan />,
  },
  {
    path: "/dsst-spick",
    element: <DsstSpick />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;